import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { Fade } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useState } from 'react';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import SquareIcon from '@mui/icons-material/Square';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useShoppingCart } from '@/context/ShoppingCartContext';
export const DroneLegendDialog = () => {
  const [minimized, setMinimized] = useState(false);
  const { setTaskingMapLegends } = useShoppingCart();

  const tooltipSlotProps = {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -10],
          },
        },
      ],
    },
  };
  return minimized ? (
    <Fade in={minimized} mountOnEnter unmountOnExit>
      <Box className="drone-legend-dialog-bar-wrap">
        <IconButton
          className="drone-legend-dialog-bar-content"
          onClick={() => {
            setMinimized(false);
          }}
        >
          <Typography variant="body2">{'Spexi Coverage Areas'}</Typography>
          <ExpandLessOutlinedIcon className="drone-legend-dialog-bar" />
        </IconButton>
      </Box>
    </Fade>
  ) : (
    <Fade
      // unmountOnExit
      in={true}

      // {...(assuredTaskingDialog?.maximize ? { timeout: 500 } : {})}
    >
      <Box className="drone-legend-dialog-wrap drone-legend">
        <Box className="action-btns">
          <IconButton
            onClick={() => {
              setMinimized(true);
            }}
          >
            <ExpandMoreOutlinedIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
          <IconButton
            onClick={() => {
              setTaskingMapLegends({ assuredTasking: false, droneTasking: false });
            }}
          >
            <CloseOutlinedIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
        </Box>

        <Typography className="at-info-title" variant="body1">
          {'Spexi Coverage Areas'}
        </Typography>
        <List className="dt-info-list">
          <ListItem disablePadding className="dt-info-list-item">
            <ListItemIcon>
              <SquareIcon sx={{ color: '#47E1BC' }} />
            </ListItemIcon>
            <ListItemText
              color="#0096ff66"
              primary={
                <>
                  {`Standard Coverage`}
                  {` `}
                  <Tooltip
                    slotProps={tooltipSlotProps}
                    title="Regions available for instant, automated tasking"
                    placement="right"
                  >
                    <span className="info-btn sar-info-btn">
                      <InfoOutlinedIcon />
                    </span>
                  </Tooltip>
                </>
              }
            />
          </ListItem>

          <ListItem disablePadding className="dt-info-list-item">
            <ListItemIcon>
              <SquareIcon sx={{ color: '#efefef' }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  {`Extended Coverage`}
                  {` `}
                  <Tooltip
                    slotProps={tooltipSlotProps}
                    title="Areas available for manual feasibility review and custom scheduling"
                    placement="right"
                  >
                    <span className="info-btn sar-info-btn">
                      <InfoOutlinedIcon />
                    </span>
                  </Tooltip>
                </>
              }
            />
          </ListItem>
        </List>
      </Box>
    </Fade>
  );
};
